/** Plain text of OnlyFans HTML, paragraphs on their own lines (edit boxes). */
export function htmlToText(html: string): string {
  const doc = new DOMParser().parseFromString(`<body>${html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p>/gi, '</p>\n<p>')}</body>`, 'text/html')
  return doc.body.textContent ?? ''
}

/** Text typed in an edit box → OnlyFans' paragraph HTML (`<p>line</p>` per line). */
export function textToHtml(text: string): string {
  const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return text
    .split('\n')
    .map((line) => `<p>${esc(line)}</p>`)
    .join('')
}
